import type { SelectionState } from './hooks/useChatOrderSelection';
import type { ChatOrderProduct } from './ChatOrderProductCandidatesModal';
import OptionList from './OptionList';
import QuantityStepper from './QuantityStepper';
import DeliveryFeeSection from './DeliveryFeeSection';

interface ProductCardProps {
  product: ChatOrderProduct;
  isSelected: boolean;
  state: SelectionState;
  formatPrice: (amount: number) => string;
  onProductSelect: (product: ChatOrderProduct) => void;
  onOptionSelect: (product: ChatOrderProduct, optionId: string) => void;
  onIncreaseQuantity: (productId: string) => void;
  onDecreaseQuantity: (productId: string) => void;
  onToggleDeliveryFee: () => void;
  onSelectDeliveryFeeOption: (index: number) => void;
}

const ProductCard = ({
  product,
  isSelected,
  state,
  formatPrice,
  onProductSelect,
  onOptionSelect,
  onIncreaseQuantity,
  onDecreaseQuantity,
  onToggleDeliveryFee,
  onSelectDeliveryFeeOption,
}: ProductCardProps) => {
  const hasOptions = product.options.length > 0;
  const isDisabled = !hasOptions && !product.price;

  return (
    <div className="product-card">
      <div
        className="product-header"
        onClick={hasOptions || !product.price ? undefined : () => onProductSelect(product)}
      >
        {!hasOptions && (
          <div className={`product-radio ${isSelected ? 'selected' : ''}`} />
        )}
        {product.thumbnail && (
          <img
            className="product-thumbnail"
            src={product.thumbnail.thumbnail}
            alt={product.name}
          />
        )}
        <div className="product-info">
          <div className="product-name">{product.name}</div>
          {!hasOptions && (
            <div className={`product-price ${!product.price ? 'no-price' : ''}`}>
              {product.price ? formatPrice(product.price.amount) : '가격 없음'}
            </div>
          )}
        </div>
      </div>

      {hasOptions && (
        <OptionList
          product={product}
          selectedProductId={state.productId}
          selectedOptionId={state.optionId}
          formatPrice={formatPrice}
          onOptionSelect={onOptionSelect}
        />
      )}

      <div className={`product-body ${!isSelected || isDisabled ? 'disabled' : ''}`}>
        <QuantityStepper
          productId={product._id}
          isSelected={isSelected}
          quantity={isSelected ? state.quantity : 0}
          onIncrease={onIncreaseQuantity}
          onDecrease={onDecreaseQuantity}
        />

        {product.deliveryFeeOptions.length > 0 && (
          <DeliveryFeeSection
            product={product}
            isSelected={isSelected}
            includeDeliveryFee={state.includeDeliveryFee}
            selectedDeliveryFeeOptionIndex={state.selectedDeliveryFeeOptionIndex}
            formatPrice={formatPrice}
            onToggle={onToggleDeliveryFee}
            onSelectOption={onSelectDeliveryFeeOption}
          />
        )}
      </div>
    </div>
  );
};

export default ProductCard;
